<template>
  <b-field :label="$t('produitSalon.regleFacturation.field')">
    <b-select expanded v-model="produit.regleFacturationId" :disabled="disabledVal">
      <option :key="regleFacturation.id"
              :value="regleFacturation.id"
              v-for="regleFacturation in getRegleFacturation">
        {{ regleFacturation.code + ' - ' + regleFacturation.libelle + ' - '
      + $t(getTypeTraduit(regleFacturation.type)) }}
      </option>
    </b-select>
  </b-field>
</template>

<script>
import * as typesParametres from '@/store/modules/parametres-mutation-type';
import messageErreur from '@/services/general/messageErreur';
import { createNamespacedHelpers } from 'vuex';
import {
  TYPE_REGLE_FACTURATION,
} from '@/configuration/presse/regleFacturation/regleFacturationConf';

const Parametres = createNamespacedHelpers('parametres');
const Societe = createNamespacedHelpers('societe');

export default {
  name: 'regleFacturation',
  props: {
    produit: {
      type: Object,
      required: false,
    },
    detail: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      listeTypeRegleFacturation: TYPE_REGLE_FACTURATION,
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    disabledVal() {
      if (typeof this.disabled === 'boolean') return this.disabled;
      return !!this.produit.regroupementProduitId;
    },
    getRegleFacturation() {
      let societeId = this.societeActiveId;
      if (this.produit.id && this.produit?.supportCommercial?.societeId) {
        societeId = this.produit.supportCommercial.societeId;
      }
      return this.parametre(typesParametres.PARAMETRES_KEYS.regleFacturation)
        .filter(regle => regle.societeId === societeId);
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    getTypeTraduit(clef) {
      return (this.listeTypeRegleFacturation.find((el) => el.key === clef)).libelle;
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([typesParametres.PARAMETRES_KEYS.regleFacturation]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style scoped>

</style>
